import { render, staticRenderFns } from "./TopComments.vue?vue&type=template&id=c2417512&scoped=true"
import script from "./TopComments.vue?vue&type=script&lang=js"
export * from "./TopComments.vue?vue&type=script&lang=js"
import style0 from "./TopComments.vue?vue&type=style&index=0&id=c2417512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2417512",
  null
  
)

export default component.exports